import { useId } from "react"
import type { SVGProps } from "react"

export default function GradientChevron(props: SVGProps<SVGSVGElement>) {
  /* The gradient id must be unique per instance — duplicate SVG ids make
     every chevron resolve to the first def in the document, which sits
     inside a display:none hover wrapper and therefore paints nothing. */
  const gradientId = useId()

  return (
    <svg
      width="23"
      height="38"
      viewBox="0 0 23 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="22.2819"
          y1="19"
          x2="1.05016e-05"
          y2="19.015"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB36E" />
          <stop offset="1" stopColor="#F86F3E" />
        </linearGradient>
      </defs>
      <path
        d="M12.4517 2.37161C14.1044 -0.0842343 17.4407 -0.739036 19.9035 0.909074C22.3663 2.55718 23.023 5.88409 21.3702 8.33994L13.1096 20.6143C12.4722 21.5614 12.5281 22.8122 13.2476 23.699L17.7725 29.2765C19.6379 31.5759 19.2809 34.9479 16.975 36.8081C14.6691 38.6682 11.2876 38.3122 9.42213 36.0128L1.1952 25.8721C-0.286324 24.0459 -0.401518 21.4702 0.911101 19.5197L12.4517 2.37161Z"
        fill={`url(#${gradientId})`}
      />
    </svg>
  )
}
